module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.woff?d3a718bc1772e114ece0c2acbda89747";